import { lazy, Suspense, useState, useEffect } from 'react';

export function ContactDealerInlineFormLoader({ load, ...props }) {
    const [LazyForm, setLazyForm] = useState(null);
    useEffect(() => {
        if (load && !LazyForm) {
            setLazyForm(
                lazy(() =>
                    import(
                        /* webpackChunkName: "ContactDealerInlineForm" */ './ContactDealerInlineForm'
                    )
                )
            );
        }
    }, [load, LazyForm]);
    return (
        LazyForm && (
            <Suspense fallback={''}>
                <LazyForm {...props} />
            </Suspense>
        )
    );
}
